import React, { useMemo } from "react";
import { BASIC_METRICS } from "../../utils/analysisContextUtils";

const MetricSelector = ({ value, onChange, deviceId, userToken, dispatch }) => {
  // Para ahora, usamos las métricas estándares
  // En el futuro, estos podrían venir del dispositivo si tiene parámetros específicos
  const metricOptions = useMemo(() => {
    return BASIC_METRICS;
  }, []);

  const handleChange = (e) => {
    const selectedValue = e.target.value;
    if (!selectedValue) {
      onChange(null);
      return;
    }

    const selected = metricOptions.find((m) => m.value === selectedValue);
    if (selected) {
      onChange(selected.value);
    }
  };

  const selectedLabel = metricOptions.find((m) => m.value === value)?.label;

  return (
    <div className="selector-wrapper">
      <select
        className="field-select"
        value={value || ""}
        onChange={handleChange}
      >
        <option value="">Seleccionar métrica...</option>
        {metricOptions.map((metric) => (
          <option key={metric.value} value={metric.value}>
            {metric.label}
          </option>
        ))}
      </select>
      {value && <div className="selected-value">{selectedLabel}</div>}
    </div>
  );
};

export default MetricSelector;
